function insertSamplesIntoGroup(sampleGroup, new_samples) {
    new_samples.forEach(sample => {
        if (sample.parent_analysis_sample_id) {
            const parent_sample_index = sampleGroup.samples.findIndex(
                s => s.analysis_sample_id == sample.parent_analysis_sample_id
            );

            if (parent_sample_index !== -1) {
                const next_main_sample_index = sampleGroup.samples
                    .filter((s, i) => i > parent_sample_index)
                    .findIndex(s => !s.parent_analysis_sample_id);

                if (next_main_sample_index === -1) {
                    sampleGroup.samples.push(sample);
                } else {
                    const sample_index = parent_sample_index + next_main_sample_index + 1;
                    sampleGroup.samples.splice(sample_index, 0, sample);
                }
            } else {
                sampleGroup.samples.push(sample);
            }
        } else {
            sampleGroup.samples.push(sample);
        }
    });
}

let mutations = {
    ADD_IMPORTS_TO_SAMPLE_GROUP(state, params) {
        if (!params.analysis_sample_group_id || !params.samples || !params.keys || params.samples.length == 0 || params.keys.length == 0) return;

        const sample_group = state.draft.sample_groups.find(group => group.analysis_sample_group_id === params.analysis_sample_group_id);

        if (sample_group) {
            if (!_.has(sample_group, 'importing')) {
                Vue.set(sample_group, 'importing', {
                    keys: params.keys,
                    samples: params.samples,
                    order: params.keys
                });
            }
            else if (_.has(sample_group, ['importing', 'keys']) && !_.isEqual(sample_group.importing.keys.sort(), params.keys.sort())) {
                return;
            }
            else {
                sample_group.importing.samples.push(...params.samples);
            }

            if (typeof params.onSuccess === 'function') {
                params.onSuccess();
            }
        }
    },
    ADD_SAMPLE_GROUP(state, params = {}) {
        if (!state.draft.analysis_order_id) return;

        axios.post('/analysis/' + state.draft.analysis_order_id + '/groups')
            .then(response => {
                if (response.data) {
                    state.draft.sample_groups.push(response.data);

                    if (typeof params.onSuccess === 'function') {
                        params.onSuccess(response.data);
                    }
                }
            })
    },

    ADD_SAMPLES_TO_GROUP(state, { group, new_samples }) {
        if (!group || !Array.isArray(group.samples)) return;

        insertSamplesIntoGroup(group, new_samples);
    },

    ADD_TEMP_SAMPLES_TO_GROUP(state, { group, tempSamples }) {
        const sampleGroup = state.draft.sample_groups.find(
            g => g.analysis_sample_group_id === group.analysis_sample_group_id
        );

        if (!sampleGroup) return;

        if (!Array.isArray(sampleGroup.samples)) {
            Vue.set(sampleGroup, 'samples', []);
        }

        sampleGroup.samples.push(...tempSamples);
    },

    REPLACE_TEMP_SAMPLES_WITH_REAL(state, { group, tempSamples, new_samples }) {
        const sampleGroup = state.draft.sample_groups.find(
            g => g.analysis_sample_group_id === group.analysis_sample_group_id
        );

        if (!sampleGroup || !Array.isArray(sampleGroup.samples)) return;

        const overridesByIndex = [];

        // Soil default: depth = "0-"
        if (group.sample_type_id === 2223) {
            tempSamples.forEach((temp, idx) => {
                const depthDetail = (temp.details || []).find(d => d.field_key === 'depth');

                if (depthDetail && depthDetail.field_value && depthDetail.field_value !== '0-') {
                    overridesByIndex[idx] = {
                        depth: depthDetail.field_value,
                    };
                }
            });
        }

        const tempIds = new Set(tempSamples.map(s => s.analysis_sample_id));

        sampleGroup.samples = sampleGroup.samples.filter(
            sample => !tempIds.has(sample.analysis_sample_id)
        );

        const samplesToInsert = new_samples.map((sample, idx) => {
            const clone = JSON.parse(JSON.stringify(sample));
            const overrides = overridesByIndex[idx];

            if (overrides && overrides.depth != null) {
                const depthDetail = (clone.details || []).find(d => d.field_key === 'depth');
                if (depthDetail) {
                    depthDetail.field_value = overrides.depth;
                } else {
                    clone.details = clone.details || [];
                    clone.details.push({
                        field_key: 'depth',
                        field_value: overrides.depth,
                    });
                }
            }

            return clone;
        });

        insertSamplesIntoGroup(sampleGroup, samplesToInsert);
    },

    REMOVE_TEMP_SAMPLES_FROM_GROUP(state, { group, tempSamples }) {
        const sampleGroup = state.draft.sample_groups.find(
            g => g.analysis_sample_group_id === group.analysis_sample_group_id
        );

        if (!sampleGroup || !Array.isArray(sampleGroup.samples)) return;

        const tempIds = new Set(tempSamples.map(s => s.analysis_sample_id));

        sampleGroup.samples = sampleGroup.samples.filter(
            sample => !tempIds.has(sample.analysis_sample_id)
        );
    },

    CHANGE_SCREEN_LAYOUT(state, layout) {
        state.screen_layout = layout;
    },
    DELETE_ITEM_KEY(state, params) {
        if (_.has(params, 'item') && _.has(params, 'key')) {
            Vue.delete(params.item, params.key);
        }
    },
    DISMISS_ERROR(state, index) {
        state.errors.splice(index, 1);
    },
    GET_SOIL_CROP_DATA(state) {
        if (state.soil_crop_data.length > 0 || state.loading.soil_crop_data) return;

        state.loaded.soil_crop_data = false;
        state.loading.soil_crop_data = true;

        axios.get('/soils/recommendations/crops')
            .then((response) => {
                if (response.data) {
                    state.soil_crop_data = response.data.map(crop => {
                        crop.average_yield = parseInt(crop.average_yield);
                        return crop;
                    });

                    state.loaded.soil_crop_data = true;
                }

                state.loading.soil_crop_data = false;
            })
    },
    INITIALIZE_TEST_DETAILS_MODAL(state, el) {
        state.test_details.modal = $(el);
    },
    UPDATE_DRAFT_ORDER(state, draft) {
        // TODO: why is this so slow to load?
        state.draft = draft;
        state.loading.draft_order = _.isEmpty(draft);
        state.loaded.draft_order = !state.loading.draft_order;
    },
    UPDATE_LOADING(state, loading) {
        for (const item in loading) {
            Vue.set(state.loading, item, loading[item]);
        }
    },
    LOAD_SAMPLE_TYPE_FIELDS(state, sample_type_id) {
        if (!_.has(state.sample_type_fields, sample_type_id) && !state.loading.sample_type_fields[sample_type_id]) {
            Vue.set(state.loaded.sample_type_fields, sample_type_id, false);
            Vue.set(state.loading.sample_type_fields, sample_type_id, true);

            axios.get('/analysis/custom-fields', {
                params: {
                    account_number: state.account.account_nbr,
                    sample_type_id: sample_type_id
                }
            })
                .then((response) => {
                    if (response.data) {
                        let fields = response.data;

                        Vue.set(state.sample_type_fields, sample_type_id, {
                            order: fields.order_fields,
                            group: fields.group_fields,
                            sample: {
                                id: fields.sample_id,
                                other: fields.sample_fields
                            },
                            child_sample: fields.child_sample_fields,
                            links: fields.links
                        });

                        Vue.set(state.loading.sample_type_fields, sample_type_id, false);
                        Vue.set(state.loaded.sample_type_fields, sample_type_id, true);
                    }
                });
        }
    },
    LOAD_SAMPLE_TYPE_TESTS(state, sample_type_id) {
        if (!_.has(state.sample_type_test_groups, sample_type_id)) {
            Vue.set(state.loaded.sample_type_test_groups, sample_type_id, false);
            Vue.set(state.loading.sample_type_test_groups, sample_type_id, true);
            Vue.set(state.sample_type_test_groups, sample_type_id, []);

            axios.get('/analysis/tests', {
                params: {
                    account_number: state.account.account_nbr,
                    sample_type_id: sample_type_id
                }
            })
                .then((response) => {
                    if (response.data) {
                        Vue.set(state.sample_type_test_groups, sample_type_id, response.data);
                        Vue.set(state.loading.sample_type_test_groups, sample_type_id, false);
                        Vue.set(state.loaded.sample_type_test_groups, sample_type_id, true);
                    }
                })
        }
    },
    LOAD_SAMPLE_TYPE_GROUPS(state) {
        if (_.has(state.account, 'account_nbr') && !state.loading.sample_type_groups) {
            state.sample_type_groups = [];
            state.loading.sample_type_groups = true;
            state.loaded.sample_type_groups = false;

            axios.get('/analysis/sample-types/' + state.account.account_nbr)
                .then((response) => {
                    if (response.data) {
                        state.sample_type_groups = response.data;
                        state.loading.sample_type_groups = false;
                        state.loaded.sample_type_groups = true;
                    }
                });
        }
    },
    REMOVE_ITEM_FROM_ARRAY(state, params) {
        if (_.has(params, 'array') && _.has(params, 'item')) {
            const item_index = params.array.findIndex(item => item === params.item);

            if (item_index !== -1) {
                params.array.splice(item_index, 1);
            }
        }
    },
    REMOVE_SAMPLE_GROUP(state, group) {
        if (!group || !group.analysis_sample_group_id) return;

        Vue.set(state.loading, 'updating_samples', true);

        const removeFromDraft = () => {
            let deleted_sample_group = state.draft.sample_groups
                .map((draft_group, index) => {
                    draft_group.draft_group_index = index;
                    return draft_group;
                })
                .find(draft_group => draft_group.analysis_sample_group_id == group.analysis_sample_group_id);

            if (_.has(deleted_sample_group, 'draft_group_index')) {
                state.draft.sample_groups.splice(deleted_sample_group.draft_group_index, 1);
            }

            Vue.set(state.loading, 'updating_samples', false);
        };

        axios
            .delete(
                '/analysis/' + state.draft.analysis_order_id + '/groups/' + group.analysis_sample_group_id
            )
            .then(removeFromDraft)
            .catch(() => {
                Vue.set(state.loading, 'updating_samples', false);
            });
    },
    REMOVE_SAMPLE_FROM_GROUP(state, { group, sample }) {
        if (!sample || !sample.analysis_sample_group_id || !sample.analysis_sample_id) return;

        Vue.set(state.loading, 'updating_samples', true);

        axios.delete('/analysis/' + state.draft.analysis_order_id + '/groups/' + sample.analysis_sample_group_id + '/samples/' + sample.analysis_sample_id)
            .then(response => {
                let sample_indexes = [];

                group.samples.map((group_sample, index) => {
                    group_sample.sample_index = index;
                    return group_sample;
                })
                    .forEach(group_sample => {
                        if (group_sample.analysis_sample_id == sample.analysis_sample_id || group_sample.parent_analysis_sample_id == sample.analysis_sample_id) {
                            sample_indexes.push(group_sample.sample_index);
                        }
                    });

                sample_indexes.reverse().forEach(sample_index => {
                    group.samples.splice(sample_index, 1);
                });

                Vue.set(state.loading, 'updating_samples', false);
            })
    },
    REMOVE_SAMPLES_FROM_GROUP(state, { group, analysis_sample_ids }) {
        if (!Array.isArray(analysis_sample_ids) || analysis_sample_ids.length === 0) return;

        let sample_indexes = [];

        group.samples
            .map((group_sample, index) => {
                group_sample.sample_index = index;
                return group_sample;
            })
            .forEach(group_sample => {
                if (
                    analysis_sample_ids.includes(group_sample.analysis_sample_id) ||
                    analysis_sample_ids.includes(group_sample.parent_analysis_sample_id)
                ) {
                    sample_indexes.push(group_sample.sample_index);
                }
            });

        sample_indexes.reverse().forEach(sample_index => {
            group.samples.splice(sample_index, 1);
        });
    },
    REMOVE_SOIL_REC(state, { sample, rec_index }) {
        sample.soilrecs.splice(rec_index, 1);
    },
    SAVE_ORDER_DETAILS(state) {
        if (!state.draft || !state.draft.analysis_order_id || state.draft.saving) return;

        Vue.set(state.draft, 'saving', true);

        axios.put('/analysis/' + state.draft.analysis_order_id + '/details', {
            details: state.draft.details
        })
            .then(response => {
                if (response.data && response.data.details) {
                    Vue.set(state.draft, 'details', response.data.details)
                }

                Vue.nextTick(() => { Vue.set(state.draft, 'saving', false) });
            })
    },
    SHOW_TEST_DETAILS(state, { sample_type, test }) {
        if (!sample_type || !test) return;

        const sample_type_id = sample_type.sampleTypeID;
        const test_id = test.ID;

        state.test_details.modal.modal('show');
        state.test_details.visible_test_id = test_id;

        if (!state.test_details.data[test_id]) {
            axios.get('/analysis/tests/' + sample_type_id + '/' + test_id)
                .then((response) => {
                    if (response.data) {
                        Vue.set(state.test_details.data, test_id, {
                            caption: test.caption,
                            price: test.price,
                            details: response.data
                        });
                    }
                });
        }
    },
    SET_ACCOUNT(state, account) {
        state.account = account;
        Vue.set(state.loaded, 'sample_type_fields', {});
        Vue.set(state, 'sample_type_fields', {});
        Vue.set(state.loaded, 'sample_type_test_groups', {});
        Vue.set(state, 'sample_type_test_groups', {});
    },
    SET_ITEM_VALUE(state, params) {
        if (_.has(params, 'item') && _.has(params, 'key') && _.has(params, 'value')) {
            Vue.set(params.item, params.key, params.value);
        }
    },
    SET_USER(state, user) {
        state.user = user;
    },
    SUBMIT_DRAFT_ORDER(state) {
        if (!state.draft.analysis_order_id) return;

        Vue.set(state.loading, 'draft_order', true);

        axios.post('/analysis/' + state.draft.analysis_order_id + '/submit')
            .then(response => {
                if (response.data) {
                    Vue.set(state, 'completed_order', response.data);
                }

                Vue.set(state.loading, 'draft_order', false);
            })
            .catch(error => {
                let errors = _.has(error, ['response', 'data', 'errors']) ? error.response.data.errors : {};
                errors = Object.keys(errors).map(item => errors[item]).flatten();
                const error_message = errors.length > 0 ? errors[0] : '';
                console.log({ error_message, errors });
                Vue.set(state.loading, 'draft_order', false);
                toastr.error(`There was an error submitting your order.<br><br>${error_message}`, 'Error', {
                    positionClass: 'toast-bottom-right',
                    closeButton: true,
                    tapToDismiss: false,
                    timeOut: 0,
                    extendedTimeOut: 0
                });
            })
    },
    UPDATE_AVAILABLE_CROPS(state, available_crops = []) {
        state.available_crops = available_crops;
    },
    UPDATE_IMPORT_FILE(state, import_file = false) {
        state.import_file = import_file;
    },
    UPDATE_USER_BILLING(state, can_see = false) {
        state.user_can_see_billing = can_see;
    },
    UPDATING_SAMPLES(state, updating = true) {
        Vue.set(state.loading, 'updating_samples', updating);
    },
    UPDATE_UNAVAILABLE_TESTS(state, { group, unavailable_tests }) {
        Vue.set(group, 'unavailable_tests', unavailable_tests);
    },
    LOAD_TEST_BLACKLIST(state) {
        if (!state.loading.test_blacklist) {
            state.test_blacklist = [];
            state.loading.test_blacklist = true;
            state.loaded.test_blacklist = false;

            axios.get('/analysis/testBlacklist/' + state.account.account_nbr)
                .then((response) => {
                    if (response.data) {
                        state.test_blacklist = response.data;
                        state.loading.test_blacklist = false;
                        state.loaded.test_blacklist = true;
                    }
                });
        }
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/analysis/mutations.js